import IconButton from '@mui/material/IconButton';
import PaymentIcon from '@mui/icons-material/Payment';
import { useSelector, useStore } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import PaidIcon from '@mui/icons-material/Paid';
import Tooltip from '@mui/material/Tooltip';

interface AddToPaymentCartProps {
  id: number;
  addToBalance: boolean;
  company?: {
    value: number;
    label: string;
  };
  payment?: {
    id?: number;
  };
}

export default function AddToPaymentCart({ id, addToBalance, company, payment }: AddToPaymentCartProps) {
  const store = useStore();
  const paymentCompany = useSelector((state: any) => state?.payment?.companyID);

  function addToCartButton() {
    return addToBalance ? (
      <Tooltip title="Add to payment cart" placement="left" arrow>
        <IconButton
          style={{ color: '#2e7d32' }}
          onClick={() => {
            if (!company?.value) {
              toastr.warning('No Company', 'Please Select Company First');
              return;
            }

            if (paymentCompany !== null && paymentCompany !== company?.value) {
              toastr.warning('Not Same Company', 'Please add payment from same company');
              return;
            }

            store.dispatch({ type: 'ADD_PARCEL_ID', payload: id });
            store.dispatch({ type: 'UPDATE_COMPANY_ID', payload: company?.value });
          }}
        >
          <PaymentIcon />
        </IconButton>
      </Tooltip>
    ) : (
      <Tooltip title="Balance not added yet" placement="left" arrow>
        <IconButton style={{ color: '#979797' }}>
          <PaymentIcon />
        </IconButton>
      </Tooltip>
    );
  }

  function openPayment(id: number) {
    return (
      <Tooltip title="View payment details" placement="left" arrow>
        <IconButton
          style={{ color: '#979797' }}
          onClick={() => {
            window.open(`/dashboard/paymentshow/${id}`, '_blank');
          }}
        >
          <PaidIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return <>{payment?.id ? openPayment(payment.id) : addToCartButton()}</>;
}
